import { User } from "./types";

export const initialState: User = {
  root: false,
  name: "Guest",
  picture: "",
  roles: [],
  privileges: [],
};
